<template>
  <div v-if="remaining" class="time-remaining">
    <div v-if="remaining.days !== undefined && remaining.days > 0" class="time-remaining__item">
      <div>
        <p class="time-remaining__time">{{ remaining.days }}</p>
        <span class="time-remaining__notation">{{ messages.days }}</span>
      </div>
      <span v-if="remaining.days !== undefined && remaining.days > 0" class="time-remaining__colon"
        >:</span
      >
    </div>
    <div v-if="remaining.hours !== undefined" class="time-remaining__item">
      <div>
        <p class="time-remaining__time">{{ remaining.hours }}</p>
        <span class="time-remaining__notation">{{ messages.hours }}</span>
      </div>
      <span class="time-remaining__colon">:</span>
    </div>
    <div v-if="remaining.minutes !== undefined" class="time-remaining__item">
      <div>
        <p class="time-remaining__time">{{ remaining.minutes }}</p>
        <span class="time-remaining__notation">{{ messages.minutes }}</span>
      </div>
      <span
        v-if="remaining.seconds !== undefined && remaining.days < 1"
        class="time-remaining__colon"
        >:</span
      >
    </div>
    <div v-if="remaining.seconds !== undefined && remaining.days < 1" class="time-remaining__item">
      <div>
        <p class="time-remaining__time">{{ remaining.seconds }}</p>
        <span class="time-remaining__notation">{{ messages.seconds }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeRemaining',
  props: {
    result: {
      type: Object,
      default: () => ({
        endTime: '2023-02-12',
      }),
    },
    messages: {
      type: Object,
      default: () => ({
        days: 'дні',
        hours: 'Год',
        minutes: 'Хв',
        seconds: 'сек',
      }),
    },
  },
  data() {
    return {
      remaining: {},
      interval: '',
    };
  },
  mounted() {
    if (parseInt(this.result.endTime) == this.result.endTime) {
      var deadline = new Date(this.result.endTime * 1000);
    } else {
      var deadline = new Date(Date.parse(this.result.endTime));
    }

    this.remaining = this.getTimeRemaining(deadline);
    this.interval = setInterval(() => {
      this.remaining = this.getTimeRemaining(deadline);
      if (this.remaining.total === 0) {
        clearInterval(this.interval);
      }
    }, 1000);
  },
  methods: {
    getTimeRemaining(endtime) {
      const t = Date.parse(endtime) - Date.parse(new Date());
      const seconds = Math.floor((t / 1000) % 60);
      const minutes = Math.floor((t / 1000 / 60) % 60);
      const hours = Math.floor((t / (1000 * 60 * 60)) % 24);
      const days = Math.floor(t / (1000 * 60 * 60 * 24));
      return {
        total: t < 10 ? `0${t}` : t,
        days: days < 10 ? `0${days}` : days,
        hours: hours < 10 ? `0${hours}` : hours,
        minutes: minutes < 10 ? `0${minutes}` : minutes,
        seconds: seconds < 10 ? `0${seconds}` : seconds,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.time-remaining {
  display: flex;
  color: var(--text-colour-primary);
  text-align: center;
  margin-bottom: 32px;
  @include point-md {
    margin-bottom: 0;
  }
  &__item {
    display: flex;
  }
  &__time,
  &__colon {
    font-weight: 700;
    font-size: rem(40);
    line-height: 120%;
    text-align: center;
    @include point-lg {
      font-size: rem(48);
    }
  }
  &__time {
    min-width: 55px;
  }
  &__colon {
    margin: 0 14px;
  }
  &__notation {
    font-weight: 500;
    font-size: rem(10);
    line-height: 115%;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    @include point-lg {
      font-size: rem(12);
    }
  }
}
</style>
